var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCreditCardCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8a2 2 0 012-2h24a2 2 0 012 2v16a2 2 0 01-2 2H4a2 2 0 01-2-2V8z",
    fill: "#007C2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.826 10.733c.382.056.738.15 1.088.284.59.225 1.064.539 1.438.95l-.867 1.732c-.659-.754-1.486-1.136-2.48-1.136-.472 0-.846.099-1.111.285-.266.195-.405.45-.405.773 0 .284.109.529.335.715.227.186.581.362 1.074.499l.895.265c.974.274 1.682.656 2.145 1.145.462.49.689 1.126.689 1.9 0 .636-.158 1.194-.463 1.673-.305.47-.738.842-1.289 1.097a4.022 4.022 0 01-1.049.308V23h-1.678v-1.744a5.448 5.448 0 01-1.495-.38c-.679-.284-1.23-.675-1.653-1.175l.847-1.742c.797.979 1.78 1.468 2.952 1.468.521 0 .925-.098 1.2-.293.276-.196.413-.471.413-.833l.01-.01c0-.323-.118-.587-.354-.793-.236-.206-.64-.381-1.2-.558l-.906-.264c-.905-.265-1.564-.627-1.987-1.087-.423-.46-.64-1.047-.64-1.781 0-.617.157-1.166.462-1.636.305-.47.738-.833 1.289-1.097a4.006 4.006 0 011.062-.33V9h1.678v1.733z",
    fill: "#fff"
  })));
}

export default SvgIconCreditCardCash;